import { useNavigate } from "react-router-dom";

import { Button } from "components/ui/Button";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { pathGenerators } from "utils/routes";

import { ConsultationsTable } from "../ConsultationsTable/ConsultationsTable";
import styles from "./ConsultationsCard.module.css";

export const ConsultationsCard = () => {
  const navigate = useNavigate();
  const patientId = useCurrentPatientId();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Consultations</h2>
        <Button
          variant="text"
          disabled={!patientId}
          onClick={() => navigate(pathGenerators.patient.consult(patientId))}
        >
          Start consultation
        </Button>
      </div>
      <div className={styles.wrapper}>
        <ConsultationsTable />
      </div>
    </div>
  );
};
